module.exports = __webpack_public_path__ + "static/media/14.4ba631d8.jpg";